import { render } from "./edit.vue?vue&type=template&id=63663cfc"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/parts/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63663cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63663cfc', __exports__)) {
    console.log('reload')
    api.reload('63663cfc', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=63663cfc", () => {
    console.log('re-render')
    api.rerender('63663cfc', render)
  })

}


export default __exports__